module.exports = __webpack_public_path__ + "static/media/ios-brush.61f0abe9.svg";